/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/prefer-promise-reject-errors */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { toast } from "../index";
import { z } from "zod";

import customerLogo from "assets/images/ct-logo.png";
import lynxLogo from "assets/images/logo.png";
// @ts-expect-error react-excel-renderer ships without types
import { ExcelRenderer } from "react-excel-renderer";
import type {
  BagType,
  CoinsDenom,
  Currency,
  PackedCurrency,
} from "./types/lookup.type";

let id = crypto.randomUUID();

export function showToast(
  status: "info" | "warning" | "success" | "error" | "loading" | undefined,
  description: string,
  title?: string,
) {
  if (toast.isActive(id)) toast.close(id);
  id = crypto.randomUUID();
  return toast({ status, title, description, id });
}

export function parseJwt(token: string) {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
}

export function isNumeric(n: string) {
  return !isNaN(parseFloat(n)) && isFinite(parseInt(n));
}

export function isOperationAllowed(mainRoute: string, subroute?: string) {
  const permissions = parseJwt(
    sessionStorage.getItem("token") || "",
  )?.Permissions;

  return mainRoute
    ? subroute
      ? permissions?.split(",")?.includes(`${mainRoute}-${subroute}`)
      : permissions?.includes(mainRoute)
    : true;
}

// Helper function to read a file and return a promise
export const readFileAsDataURL = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result as string);
    };
    reader.onerror = () => {
      reject(reader.error);
    };
    reader.readAsDataURL(file);
  });
};

// Helper function to create a file object and push it to attachments
export const createFileObject = (
  file: File,
  result: string,
  prefix: string,
) => {
  const fileType = file.type.split("/")[1];
  return {
    fileName: `${prefix}.${fileType}`,
    contentType: file.type,
    contents: result.split(",")[1],
    viewContent: result.split(",")[0],
  };
};

// Helper function to create a file validation schema
export const createFileSchema = (label: string, isRequired = true) => {
  const schema = z
    .instanceof(File, {
      message: `${label} is required.`,
    })
    .refine((file) => file.size < 7000000, {
      message: `${label} must be less than 7MB.`,
    });

  return isRequired ? schema : schema.optional();
};

export function getCustomerLogo() {
  const client = process.env.REACT_APP_CLIENT;
  let logo = lynxLogo;
  switch (client) {
    case "CT":
      logo = customerLogo;
      break;
    default:
      break;
  }

  return logo;
}

export function readOnlyExcelDate(excelDateString: string | Date | number) {
  // If the date is already in the expected format, return as is
  if (typeof excelDateString === "string" && excelDateString.includes(" ")) {
    return excelDateString;
  }

  // If it's a date object, format it to match the Excel format
  if (excelDateString instanceof Date) {
    const year = excelDateString.getFullYear();
    const month = String(excelDateString.getMonth() + 1).padStart(2, "0");
    const day = String(excelDateString.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  // If it's a serial Excel date number, convert it
  if (typeof excelDateString === "number") {
    const baseDate = new Date(1899, 11, 30); // Excel's date base
    const date = new Date(
      baseDate.getTime() + excelDateString * 24 * 60 * 60 * 1000,
    );
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}T00:00:00.000Z`;
  }

  return excelDateString; // Return as is if none of the above
}

interface Denomination {
  denomination: string;
  count: number;
  shape: string;
}

interface BagPayload {
  serviceDate: string;
  routeNo: string;
  shift: string;
  sourceBarcode: string;
  onwardBarcode: string;
  consignmentType: string;
  containerType: string;
  containerId: string;
  currency: string;
  declaredValue: number;
  count: number;
  sealNo: string;
  remarks: string;
  details: string;
  exchangeRate: number;
  chequePieces: number;
  denominations: Denomination[];
  packedCurrencies: PackedCurrency[];
}

export const onSealFileUploadPayload = (
  event: any,
  type: string,
  allBagTypes: BagType[],
  coinContainers: CoinsDenom[],
  currencies: Currency[],
  isTGDelivery?: boolean,
): Promise<BagPayload[]> => {
  return new Promise((resolve) => {
    const fileObj = event?.target?.files?.[0] as File | null;
    if (!fileObj) {
      showToast("error", "No file selected.");
      resolve([]);
      return;
    }

    const supportedTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "csv",
      "text/csv",
    ];

    const filename = (fileObj.name || "").toLowerCase();
    const extOk =
      filename.endsWith(".csv") ||
      filename.endsWith(".xls") ||
      filename.endsWith(".xlsx");

    if (!supportedTypes.includes(fileObj.type) && !extOk) {
      showToast("error", "File format not supported.");
      resolve([]);
      return;
    }

    ExcelRenderer(fileObj, (err: any, resp: any) => {
      if (err) {
        showToast("error", `Error reading file: ${String(err)}`);
        resolve([]);
        return;
      }

      const rows = resp?.rows || [];

      if (!rows.length) {
        showToast("error", "Excel sheet is empty.");
        resolve([]);
        return;
      }

      const headers = rows[0].map((header: any) => String(header || "").trim());
      const bagList: BagPayload[] = [];
      const errors: string[] = [];
      const sealSet = new Set<string>(); // 👈 ADD THIS

      for (let idx = 1; idx < rows.length; idx += 1) {
        const row = rows[idx] || [];

        const allEmpty = row.every(
          (c: any) => c === null || c === undefined || String(c).trim() === "",
        );
        if (allEmpty) continue;

        try {
          const rowData: Record<string, any> = {};

          headers.forEach((header: string, colIndex: number) => {
            if (colIndex < row.length) {
              rowData[header] = row[colIndex];
            }
          });

          const payload = transformToPayload(
            rowData,
            headers,
            type,
            allBagTypes,
            coinContainers,
            currencies,
            isTGDelivery,
          ); // Pass headers here
          if (payload) {
            console.log("payload", payload);
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            const seal = payload.sealNo?.trim();

            if (seal && sealSet.has(seal)) {
              errors.push(`Row ${idx + 1}: Duplicate Seal No (${seal})`);
              continue;
            }

            if (seal) {
              sealSet.add(seal);
            }

            bagList.push(payload);
          }
        } catch (error) {
          errors.push(`Row ${idx + 1}: Error processing data`);
        }
      }

      if (errors.length > 0) {
        showToast(
          "warning",
          `${errors.length} row(s) had errors. ${errors.slice(0, 3).join("; ")}${errors.length > 3 ? "..." : ""}`,
        );
      }

      if (bagList.length > 0) {
        // showToast(
        //   "success",
        //   `Successfully processed ${bagList.length} record(s)`,
        // );
        resolve(bagList);
      } else {
        showToast("error", "No valid data found after processing.");
        resolve([]);
      }
    });
  });
};

const transformToPayload = (
  rowData: Record<string, any>,
  headers: string[],
  type: string,
  allBagTypes: BagType[],
  coinContainers: CoinsDenom[],
  currencies: Currency[],
  isTGDelivery?: boolean,
): BagPayload | null => {
  // Map Excel column names to payload field names

  const bagType =
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    allBagTypes?.find((i) => i?.code === rowData["Bag Type"]);

  const denom = rowData.Denomination;
  const serviceDate = convertToISODate(rowData["Service Date"]);
  const routeNo = String(rowData["Route No"] || "").trim();
  const sourceBarcode = String(
    rowData["Source Barcode"] || rowData["Cash Center Barcode"] || "",
  ).trim();
  const onwardBarcode = String(
    rowData["Onward Barcode"] || rowData["Location Barcode"] || "",
  ).trim();
  const sealNo = String(rowData["Seal No"] || "").trim();
  const containerType = bagType?.description || "";
  const consignmentType = bagType?.consignmentType || "";
  const containerId = String(rowData["Bag Type"] || "").trim();
  const curr = String(rowData.Currency || "").trim();
  const currency =
    (containerType === "Foreign Currency" && !curr) ||
    (type === "Small Denominations" && containerId === "12")
      ? "FC"
      : curr;
  const notes = Number(rowData.Notes) || 0;
  const declaredValue =
    type === "Small Denominations" && containerId !== "12"
      ? denom * notes
      : Number(rowData.Value) || 0;
  const count = Number(rowData.Count) || 1;
  const details =
    containerId !== "12"
      ? denom && notes
        ? `${currency} ${denom}`
        : denom
      : "";
  const remarks = String(rowData.Remarks || "").trim();
  const chequePieces = Number(rowData["Cheque Pieces"]) || 0;

  // Check minimum required fields
  if (
    !isTGDelivery &&
    (!serviceDate || !sourceBarcode || !onwardBarcode || !containerType)
  ) {
    return null;
  }

  if (isTGDelivery && !sourceBarcode) {
    return null;
  }

  // Process all currency columns into denominations
  const denominations: Denomination[] = [];
  const packedCurrencies: PackedCurrency[] = [];
  const noteNumber = Number(details?.split(" ")[1]);
  const coinsValue: number =
    details && count && !notes
      ? // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        (coinContainers?.find(
          (i) =>
            i.denomination === details && i.containerType === containerType,
        )?.valuePerContainer || 0) * count
      : notes && details
        ? noteNumber * notes
        : 0;

  let totalDeclaredValue = 0;

  // Process all columns after the first 7 as potential currency columns
  if (type === "Foreign Currency") {
    headers.forEach((header, index) => {
      // Skip first 7 columns (fixed columns)
      const skipCol = isTGDelivery ? 3 : 6;
      if (index >= skipCol) {
        const amount = Number(rowData[header]) || 0;
        if (amount > 0) {
          const exchangeRate =
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            currencies?.find((i) => i.shortName === header)?.exchangeRate || 1;
          const value = amount * exchangeRate;
          packedCurrencies.push({
            currency: header, // Use the header as currency code
            declaredValue: amount,
            exchangeRate,
          });
          totalDeclaredValue = totalDeclaredValue + value;
        }
      }
    });
  }
  if (type === "Small Denominations" && containerId === "12") {
    const amount = denom * notes || 0;
    if (amount > 0) {
      const exchangeRate =
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        currencies?.find((i) => i.shortName === curr)?.exchangeRate || 1;
      const value = amount * exchangeRate;
      packedCurrencies.push({
        currency: curr, // Use the header as currency code
        declaredValue: amount,
        exchangeRate,
      });
      totalDeclaredValue = totalDeclaredValue + value;
    }
  }
  if (type === "AED & Coins") {
    headers.forEach((header, index) => {
      // Skip first 8 columns (fixed columns)
      const skipCol = isTGDelivery ? 4 : 7;
      if (index >= skipCol) {
        const amount = Number(rowData[header]) || 0;
        if (amount > 0) {
          const title = header.split(" ");
          denominations.push({
            denomination: `${title[0]} ${title[1]}`,
            shape: title[2],
            count: amount,
          });
          totalDeclaredValue = totalDeclaredValue + amount * Number(title[1]);
        }
      }
    });
  }

  const exchangeRate =
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    currencies?.find((i) => i.shortName === currency)?.exchangeRate || 1;

  return {
    serviceDate,
    routeNo,
    shift: "morning",
    sourceBarcode,
    onwardBarcode,
    consignmentType,
    containerType,
    containerId,
    currency: type === "AED & Coins" || type === "AED Coins" ? "AED" : currency,
    declaredValue: declaredValue || coinsValue || totalDeclaredValue || 0,
    count,
    sealNo,
    remarks,
    details,
    denominations,
    packedCurrencies,
    exchangeRate,
    chequePieces,
  };
};

const convertToISODate = (value: any): string => {
  if (!value) return "";

  try {
    if (typeof value === "number") {
      // Excel serial number
      const date = new Date(Math.round((value - 25569) * 86400 * 1000));
      return date.toISOString();
    }

    if (typeof value === "string") {
      // Handle date strings like "2025-09-30"
      if (value.includes("-")) {
        const date = new Date(value);
        if (!isNaN(date.getTime())) {
          return date.toISOString();
        }
      }
      // Handle date strings with time like "2025-09-30 00:00:00"
      const date = new Date(value);
      if (!isNaN(date.getTime())) {
        return date.toISOString();
      }
    }

    const date = new Date(value);
    if (!isNaN(date.getTime())) {
      return date.toISOString();
    }
  } catch (error) {
    // Ignore conversion errors
  }

  return "";
};

export function isArrivalBeforeGeneration(
  arrivalTime: string | Date,
  generationTime: string | Date,
) {
  return new Date(arrivalTime) < new Date(generationTime);
}

export const getLink = (serviceType: string) => {
  switch (serviceType) {
    case "Collection":
      return `/collections-detail`;
    case "Delivery":
      return `/deliveries-detail`;
    case "B2B Service":
      return `/b2b-services-detail`;
    case "Kiosk Service":
      return `/kiosk-detail`;
    case "Replenishment":
      return `/replenishment-detail`;
    case "Clearance":
      return `/clearance-detail`;
    case "Interbranch Service":
      return `/inter-branch-services-detail`;
    case "Exchange Service":
      return `/exchange-services-detail`;
    default:
      return "#";
  }
};

export function checkArrayHasSameId(arr: any[]) {
  if (arr.length === 0) return true;
  const firstId = arr[0].orderId;
  return arr.every((obj) => obj.orderId === firstId);
}

export function checkAllObjectsExist(array1: any[], array2: any[]) {
  // Count occurrences of each id in array1
  const countArray1: any = {};
  array1.forEach((item) => {
    countArray1[item.orderId] = (countArray1[item.orderId] || 0) + 1;
  });

  // Count occurrences of each id in array2
  const countArray2: any = {};
  array2.forEach((item) => {
    countArray2[item.orderId] = (countArray2[item.orderId] || 0) + 1;
  });

  // Check for mismatches
  const errors = [];

  // Check each id that exists in both arrays
  for (const id in countArray1) {
    if (countArray2[id] !== undefined) {
      if (countArray1[id] !== countArray2[id]) {
        errors.push(`Not all packages scanned for Order ID ${id}.`);
      }
    }
    // If id is only in array1 and not in array2, ignore (like id 13)
  }

  // Display results
  if (errors.length > 0) {
    return errors;
  }
  // After slection check: verify all objects have scanned: true
  const invalidScanned = array2.filter((item) => item.scanned !== true);

  if (invalidScanned.length > 0) {
    invalidScanned.forEach((item) => {
      errors.push(`Package with seal (${item.sealNo}) not scanned.`);
    });
  }
  if (errors.length > 0) {
    return errors;
  }
  return false;
}
